module.exports = __webpack_public_path__ + "static/img/guan2.8fc1e91.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/guan2.jpg
// module id = 8nWy
// module chunks = 1